
export interface ILiveFlightSyncStatus {
  syncDate: Date;
  httpStatus: number;
  message: string;
}


export class LiveFlightSyncStatus implements ILiveFlightSyncStatus {

  public syncDate: Date;
  public httpStatus: number;
  public message: string;

  public constructor(syncDate: Date, httpStatus: number, message: string) {

    this.syncDate = syncDate;
    this.httpStatus = httpStatus;
    this.message = message;
  }

}
